import { setup } from 'xstate5';

export const networkMonitorMachine = setup({
  types: {
    events: {} as { type: 'CONNECT' } | { type: 'DISCONNECT' },
  },
}).createMachine({
  id: 'sgNetworkMonitorMachine',
  initial: 'unknown',
  states: {
    unknown: {
      on: { CONNECT: 'connected', DISCONNECT: 'disconnected' },
    },
    connected: {
      on: { DISCONNECT: 'disconnected' },
    },
    disconnected: {
      on: { CONNECT: 'connected' },
    },
  },
});
